import React from 'react'
import PropTypes from 'prop-types'
import {icon} from '@salesforce/retail-react-app/app/components/icons'
import {useCustomTheme} from '../../../context/theme'

import '../../../assets/svg/kenwood/kenwood-brand-logo.svg'
import '../../../assets/svg/delonghi/delonghi-brand-logo.svg'

import '../../../assets/svg/delonghi/delonghi-brand-logo-inverted.svg'

const DelonghiBrandLogo = icon('delonghi-brand-logo', {viewBox: '0 0 169 55'})
const KenwoodBrandLogo = icon('kenwood-brand-logo', {viewBox: '0 0 180 27'})

const DelonghiBrandLogoInverted = icon('delonghi-brand-logo-inverted', {viewBox: '0 0 169 55'})

const BrandLogo = (props) => {
    const {theme} = useCustomTheme()

    let Icon = null
    switch (theme.key) {
        case 'kenwood':
            Icon = KenwoodBrandLogo
            break
        case 'delonghi':
        default:
            Icon = DelonghiBrandLogo
            if (props.inverted) {
                Icon = DelonghiBrandLogoInverted
            }
            break
    }

    return <Icon {...props} inverted={props.inverted ? 'true' : undefined} />
}

BrandLogo.propTypes = {
    onClick: PropTypes.func,
    inverted: PropTypes.bool,
}

export default BrandLogo
